export default defineNuxtPlugin(() => {
  const { applyLocale } = useI18n()

  window.addEventListener('popstate', () => {
    applyLocale(localeFromPath(window.location.pathname))
  })
})